import { FC } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { setErrorToast } from '../../../store/toast';
import { getDayListForMonth, weekdayList } from '../helpers';
import { ETabDataPicker } from '../index';
import ISelectDatepicker from '../SelectDatepicker';

const DayList: FC<ISelectDatepicker.IPropsSelectedItem> = ({
  dateSelected,
  handleChange,
  minDate,
  tabSelected,
  isMaxDateCurrent,
}) => {
  const dayList = getDayListForMonth(dateSelected);

  const dispatch = useDispatch();
  return (
    <div>
      <div className="tw-grid tw-grid-cols-7">
        {weekdayList().map((abbreviatedWeekdaysItem) => (
          <div
            key={abbreviatedWeekdaysItem}
            className="tw-text-[14px]  tw-border-gray100 tw-gap-2 tw-text-gray200  tw-text-center"
          >
            {abbreviatedWeekdaysItem}
          </div>
        ))}
      </div>
      <div className="tw-pt-3">
        {Object.values(dayList).map((dayListItem, index) => (
          <div
            className="tw-text-[12px] tw-border-gray100  tw-text-gray200  tw-py-2 tw-text-center"
            key={index}
          >
            <div className="tw-grid tw-grid-cols-7 tw-gap-2">
              {weekdayList()?.map((dayItem) => {
                const day = dayListItem[dayItem];

                const disable =
                  (dateSelected &&
                    moment(dateSelected).year() === moment(minDate).year() &&
                    moment(dateSelected).month() === moment(minDate).month() &&
                    day < moment(minDate).date()) ||
                  (isMaxDateCurrent &&
                    moment(dateSelected).year() === moment(new Date()).year() &&
                    moment(dateSelected).month() === moment(new Date()).month() &&
                    day >= moment(new Date()).date());

                return day ? (
                  <div
                    key={dayItem}
                    className={`hover:tw-text-green500 tw-cursor-pointer tw-border tw-flex tw-items-center tw-justify-center
                     
                           ${
                             disable
                               ? 'tw-text-gray600 tw-cursor-not-allowed'
                               : 'tw-cursor-pointer hover:tw-text-green500 '
                           }
                     ${
                       tabSelected[ETabDataPicker.DAY] && moment(dateSelected).date() === day
                         ? 'tw-text-green500 tw-rounded-md tw-border-green500'
                         : 'tw-border-transparent'
                     }`}
                    onClick={() => {
                      if (disable) {
                        return dispatch(
                          setErrorToast({
                            title: '',
                            message: 'The selected day cannot be selected',
                          }),
                        );
                      }

                      handleChange(ETabDataPicker.DAY, day);
                    }}
                  >
                    {day}
                  </div>
                ) : (
                  <></>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DayList;
